import { Dispatch, SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";

import { getScheduleTitle } from "@/shared/functions/functions";

import { MenuAnchorEl, ROUTES, TABLE_NAMES } from "../../../../../../../shared";
import { useReleaseFeatureToggle } from "../../../../../../../shared/featureToggles/hooks";
import { FEATURE_NAMES } from "../../../../../../../shared/featureToggles/types";
import { ScheduleDto } from "../../../../../types";
import SingleDetailsAcordionItem from "../../AccordionDetailsCard/components/SingleDetailsAcordionItem";
import RemoveScheduleButton from "../../ScheduleActions/RemoveSchedule/RemoveScheduleButton";
import ScheduleDetailsButton from "../../ScheduleActions/ScheduleDetails/ScheduleDetailsButton";
import ScheduleHistoryButton from "../../ScheduleActions/ScheduleHistoryButton";
import ScheduleDetailsCardContent from "../ScheduleDetailsCardContent/ScheduleDetailsCardContent";

interface IDriverScheduleDetailsSingleCardProps {
  route: ROUTES;
  schedule: ScheduleDto;
  index: number;
  totalCount: number;
  canManageSchedules: boolean;
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
}

const DriverScheduleDetailsSingleCard = ({
  route,
  schedule,
  index,
  totalCount,
  canManageSchedules,
  setIsLoading
}: IDriverScheduleDetailsSingleCardProps) => {
  const { t } = useTranslation();
  const { isReleaseFeatureEnabled } = useReleaseFeatureToggle();

  const [isActionsOpen, setIsActionsOpen] = useState<MenuAnchorEl>(null);

  return (
    <SingleDetailsAcordionItem
      route={route}
      key={schedule.scheduleId}
      title={getScheduleTitle(t, schedule)}
      totalCount={totalCount}
      showGlobalIcon={schedule.global}
      index={index}
      setIsLoading={setIsLoading}
      collapsable
      anchorEl={isActionsOpen}
      setIsActionsOpen={setIsActionsOpen}
      titleInlineActions={
        canManageSchedules && (
          <>
            {isReleaseFeatureEnabled(FEATURE_NAMES.ShowHistoryButton) && (
              <ScheduleHistoryButton schedule={schedule} />
            )}

            <ScheduleDetailsButton
              isDriversPage
              schedule={schedule}
              onActionsMenu={setIsActionsOpen}
            />
            <RemoveScheduleButton
              route={route}
              schedule={schedule}
              onActionsMenu={setIsActionsOpen}
            />
          </>
        )
      }
    >
      <ScheduleDetailsCardContent
        schedule={schedule}
        resourceName={TABLE_NAMES.Drivers}
        //lastDownloadAttempt and lastSuccessfulDownload are going to be shown only in quick schedule until the final solution in BE is cleared out. JIRA task: TACHO-2153

        lastDownloadAttempt={schedule?.quick}
        lastSuccessfulDownload={schedule?.quick}
        currentStatus={!schedule?.quick}
      />
    </SingleDetailsAcordionItem>
  );
};

export default DriverScheduleDetailsSingleCard;
